import { createFileRoute } from "@tanstack/react-router";
import CompareTreatments from "@/pages/CompareTreatments";
export const Route = createFileRoute("/compare-treatments")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Compare Depression Treatments | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Side-by-side comparison of SAINT TMS, standard TMS, SPRAVATO, ketamine, and ECT for treatment-resistant depression. See time, evidence, and cost in Coral.",
        },
        {
          property: "og:title",
          content: "Compare Depression Treatments | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Side-by-side comparison of SAINT TMS, standard TMS, SPRAVATO, ketamine, and ECT for treatment-resistant depression. See time, evidence, and cost in Coral.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/compare-treatments",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/compare-treatments",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <CompareTreatments />;
}
